import { initWidget } from '../../utils/Shell';
import Products from '../../components/Products.vue';

initWidget('ProductsWidget', Products);
